import { lazy } from 'react';

/**
 * React.lazy wrapper that survives stale chunks after a new deploy.
 *
 * When the app is open across a redeploy, the cached index.html points at old
 * chunk hashes that no longer exist. Firebase Hosting then serves index.html
 * (text/html) for the missing .js, so the dynamic import rejects with a MIME /
 * "Failed to fetch dynamically imported module" error and the route crashes.
 *
 * On that failure we do ONE full reload to pull the fresh index.html (and the
 * current chunk hashes). A short cooldown prevents an infinite reload loop if
 * the import is failing for a genuine reason.
 */
export function lazyWithReload(factory) {
  return lazy(() =>
    factory().catch((err) => {
      const FLAG = 'chunkReloadAt';
      const last = Number(sessionStorage.getItem(FLAG) || 0);
      const isChunkError = /dynamically imported module|Failed to fetch|MIME type|Loading chunk|module script/i.test(err?.message || '');
      if (isChunkError && Date.now() - last > 10000) {
        sessionStorage.setItem(FLAG, String(Date.now()));
        window.location.reload();
        return new Promise(() => {}); // hold render while the page reloads
      }
      throw err;
    })
  );
}

export default lazyWithReload;
